import { useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { CurrentMonthData, MonthlyData, PropertyData, Reports } from "./types/analytics";




// export function useAnalytics(){
export function useAnalytics(year?: number, propertyId?: string) {
    const queryClient = useQueryClient();
    
    // const totalDepositAmount  = useQuery({
    //     queryKey: ["total-deposit-amonut"],
    //     queryFn: async ({queryKey}) => {
    //       try {
    //         const response = await axios.get(`/api/v1/total_deposit_amount`);
    //         return response.data as number;
    //       } catch (error) {
    //         console.error("Error fetching users:", error);
    //         throw error;
    //       }
    //     },
    //     staleTime: 30000,
    //   });
      const currentMonthData  = useQuery({
        queryKey: ["current-month-data"],
        queryFn: async ({queryKey}) => {
          try {
            const response = await axios.get(`/api/v1/current_month_data`);
            return response.data as CurrentMonthData;
          } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
          }
        },
        staleTime: 30000,
      });
      const currentPendingAmount  = useQuery({
        queryKey: ["current-month-pending-rent"],
        queryFn: async ({queryKey}) => {
          try {
            const response = await axios.get(`/api/v1/pending-rent`);
            return response.data as CurrentMonthData;
          } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
          }
        },
        staleTime: 30000,
      });
      // const currentYearRentCollection  = useQuery({
      //   queryKey: ["current_year_rent_collection"],
      //   queryFn: async ({queryKey}) => {
      //     try {
      //       const response = await axios.get(`/api/v1/current_year_rent_collection`);
      //     //  console.log('rent', response.data)
      //       return response.data as MonthlyData;
      //     } catch (error) {
      //       console.error("Error fetching users:", error);
      //       throw error;
      //     }
      //   },
      //   staleTime: 30000,
      // });
      
      const dashboardCounts  = useQuery({
        queryKey: ["dashboardC_counts"],
        queryFn: async ({queryKey}) => {
          try {
            const response = await axios.get(`/api/v1/counts`);
            return response.data as PropertyData;
          } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
          }
        },
        staleTime: 30000,
      });
      const report  = useQuery({
        queryKey: ["report"],
        queryFn: async ({queryKey}) => {
          try {
            const response = await axios.get(`/api/v1/report`);
            return response.data as Reports;
          } catch (error) {
            console.error("Error fetching users:", error);
            throw error;
          }
        },
        staleTime: 30000,
      });

      const detailedPendingPayments = useQuery({
        queryKey: ["detailed-pending-payments"],
        queryFn: async ({ queryKey }) => {
          try {
            const response = await axios.get(`/api/v1/rent-status`);
           // console.log("rent",response.data);
            return response.data;
          } catch (error) {
            console.error("Error fetching detailed pending payments:", error);
            throw error;
          }
        },
        staleTime: 30000,
      });
  //  const currentYearExpenses = useQuery({
  //   queryKey: ["current_year_expenses"],
  //   queryFn: async () => {
  //     try {
  //       const currentYear = new Date().getFullYear();
  //       const response = await axios.get(
  //         `/api/v1/current_year_rent_collection?type=EXPENSE&year=${currentYear}`
  //       );
  //       return response.data;
  //     } catch (error) {
  //       console.error("Error fetching expenses:", error);
  //       throw error;
  //     }
  //   },
  //   staleTime: 30000,
  // });

   const currentYearRentCollection = useQuery({
    queryKey: ["current_year_rent_collection", year, propertyId],
    queryFn: async ({ queryKey }) => {
      try {
        const [_, year, propertyId] = queryKey;
        let url = `/api/v1/current_year_rent_collection?year=${year || new Date().getFullYear()}`;
        if (propertyId) {
          url += `&propertyId=${propertyId}`;
        }
        const response = await axios.get(url);
       // console.log("rent reposne ", response.data);
        return response.data as MonthlyData;
      } catch (error) {
        console.error("Error fetching rent collection:", error);
        throw error;
      }
    },
    staleTime: 30000,
  });
  
   const currentYearExpenses = useQuery({
    queryKey: ["current_year_expenses", year, propertyId],
    queryFn: async ({ queryKey }) => {
      try {
        const [_, year, propertyId] = queryKey;
        let url = `/api/v1/current_year_rent_collection?type=EXPENSE&year=${year || new Date().getFullYear()}`;
        if (propertyId) {
          url += `&propertyId=${propertyId}`;
        }
        const response = await axios.get(url);
      //  console.log("expenses reposne ", response.data)
        return response.data;
      } catch (error) {
        console.error("Error fetching expenses:", error);
        throw error;
      }
    },
    staleTime: 30000,
  });
      
      return {report,dashboardCounts,currentPendingAmount,queryClient,currentYearRentCollection,currentMonthData,detailedPendingPayments, currentYearExpenses}     
      //return {report,dashboardCounts,queryClient,currentYearRentCollection,currentMonthData,detailedPendingPayments}        
}
